(function () {
  'use strict';

  var root = document.querySelector('[data-neko-calendar]');
  if (!root || root.hasAttribute('data-cal-ready')) return;
  var listEl = root.querySelector('[data-cal-list]');
  var chipsEl = root.querySelector('[data-cal-chips]');
  var yearEl = root.querySelector('[data-cal-year]');
  var navEl = root.querySelector('[data-cal-nav]');
  var emptyEl = root.querySelector('[data-cal-empty]');
  if (!listEl || !chipsEl || !navEl || !yearEl) return;
  root.setAttribute('data-cal-ready', 'true');

  var MS = 86400000;
  var parts = new Intl.DateTimeFormat('en', { timeZone: 'Asia/Hong_Kong', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
  function datePart(type) { return +parts.find(function (part) { return part.type === type; }).value; }
  var today = new Date(datePart('year'), datePart('month') - 1, datePart('day'));
  var currentKey = keyOf(today);

  function parseDate(s) {
    if (!s) return null;
    var p = s.split('-');
    if (p.length !== 3) return null;
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }
  function keyOf(d) {
    var m = d.getMonth() + 1;
    return d.getFullYear() + '-' + (m < 10 ? '0' + m : m);
  }

  var items = Array.prototype.slice.call(listEl.querySelectorAll('[data-cal-row]'))
    .map(function (row) {
      return {
        row: row,
        start: parseDate(row.getAttribute('data-start')),
        end: parseDate(row.getAttribute('data-end')),
        status: row.getAttribute('data-status') || ''
      };
    })
    .filter(function (it) { return it.start; });

  if (!items.length) {
    if (emptyEl) emptyEl.hidden = false;
    if (navEl) navEl.style.display = 'none';
    return;
  }

  items.sort(function (a, b) { return a.start - b.start; });

  items.forEach(function (it) {
    var badge = it.row.querySelector('[data-cal-badge]');
    if (!badge) return;
    var cls, txt;
    if (it.status === 'finished') {
      cls = 'neko-cal__badge--done';
      txt = '已結束';
      it.row.classList.add('neko-cal__row--ended');
    } else if (it.status === 'selling') {
      cls = 'neko-cal__badge--live';
      txt = '開賞中';
    } else if (it.status === 'upcoming') {
      cls = 'neko-cal__badge--soon';
      if (it.start > today) {
        txt = '倒數 ' + Math.ceil((it.start - today) / MS) + ' 日';
      } else {
        txt = '即將開售';
      }
    } else {
      if (it.start > today) {
        cls = 'neko-cal__badge--soon';
        txt = '倒數 ' + Math.ceil((it.start - today) / MS) + ' 日';
      } else if (!it.end || it.end >= today) {
        cls = 'neko-cal__badge--live';
        txt = '開賞中';
      } else {
        cls = 'neko-cal__badge--done';
        txt = '已結束';
        it.row.classList.add('neko-cal__row--ended');
      }
    }
    badge.className = 'neko-cal__badge ' + cls;
    badge.textContent = txt;
  });

  var order = [];
  var map = {};
  items.forEach(function (it) {
    var key = keyOf(it.start);
    if (!map[key]) { map[key] = { y: it.start.getFullYear(), m: it.start.getMonth() + 1, items: [] }; order.push(key); }
    map[key].items.push(it);
  });

  if (!map[currentKey]) {
    map[currentKey] = { y: today.getFullYear(), m: today.getMonth() + 1, items: [] };
    order.push(currentKey);
    order.sort();
  }

  listEl.innerHTML = '';
  order.forEach(function (key) {
    var g = map[key];
    var group = document.createElement('section');
    group.className = 'neko-cal__month';
    group.id = 'cal-m-' + key;
    group.setAttribute('aria-labelledby', 'cal-heading-' + key);
    var head = document.createElement('h2');
    head.className = 'neko-cal__mhead';
    head.id = 'cal-heading-' + key;
    head.innerHTML = '<span>' + g.y + '年 ' + g.m + '月</span><small>' + g.items.length + ' 套</small>';
    group.appendChild(head);
    g.items.forEach(function (it) { group.appendChild(it.row); });
    if (!g.items.length) {
      var empty = document.createElement('p');
      empty.className = 'neko-cal__month-empty';
      empty.textContent = '本月暫未有發售排程，睇吓其他月份啦！';
      group.appendChild(empty);
    }
    listEl.appendChild(group);
    g.element = group;
  });

  var toolbar = document.createElement('div');
  toolbar.className = 'neko-cal__toolbar';
  navEl.insertBefore(toolbar, chipsEl);
  toolbar.appendChild(yearEl);
  var rail = document.createElement('div');
  rail.className = 'neko-cal__rail';
  navEl.appendChild(rail);
  function railButton(label, glyph, direction) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'neko-cal__rail-button';
    button.textContent = glyph;
    button.setAttribute('aria-label', label);
    button.addEventListener('click', function () {
      chipsEl.scrollBy({ left: direction * chipsEl.clientWidth * 0.7, behavior: motion() });
    });
    rail.appendChild(button);
    return button;
  }
  var earlierButton = railButton('顯示較早月份', '‹', -1);
  rail.appendChild(chipsEl);
  var laterButton = railButton('顯示較後月份', '›', 1);
  chipsEl.setAttribute('role', 'navigation');
  chipsEl.setAttribute('aria-label', '發售月份');
  var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  function motion() { return motionPreference.matches ? 'auto' : 'smooth'; }
  function headerH() {
    var header = document.querySelector('.neko-header-section');
    return header ? header.getBoundingClientRect().height : 0;
  }
  function topOffset() { return headerH() + navEl.offsetHeight + 4; }
  function railState() {
    earlierButton.disabled = chipsEl.scrollLeft <= 1;
    laterButton.disabled = chipsEl.scrollLeft + chipsEl.clientWidth >= chipsEl.scrollWidth - 1;
  }
  function revealChip(chip, center) {
    var box = chip.getBoundingClientRect();
    var viewport = chipsEl.getBoundingClientRect();
    if (!center && box.left >= viewport.left + 2 && box.right <= viewport.right - 2) return;
    var left = chipsEl.scrollLeft + box.left - viewport.left - (chipsEl.clientWidth - box.width) / 2;
    chipsEl.scrollTo({ left: Math.max(0, left), behavior: 'instant' });
    railState();
  }
  var activeKey = '';
  var landing = true;
  var landingFrame = 0;
  function setActive(key) {
    if (activeKey === key) return;
    activeKey = key;
    order.forEach(function (k) {
      var chip = map[k].chip;
      chip.classList.toggle('is-active', k === key);
      if (k === key) chip.setAttribute('aria-current', 'location');
      else chip.removeAttribute('aria-current');
    });
    yearEl.textContent = map[key].y + '年 ' + map[key].m + '月';
    revealChip(map[key].chip);
  }
  function jumpTo(key, updateHistory) {
    if (!map[key]) return;
    setActive(key);
    revealChip(map[key].chip);
    if (updateHistory && window.location.hash !== '#cal-m-' + key) {
      window.history.pushState(null, '', '#cal-m-' + key);
    }
    var top = map[key].element.getBoundingClientRect().top + window.scrollY - topOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
  }
  chipsEl.innerHTML = '';
  order.forEach(function (key) {
    var g = map[key];
    var chip = document.createElement('a');
    chip.className = 'neko-cal__chip';
    chip.classList.toggle('is-past', key < currentKey);
    chip.classList.toggle('is-current', key === currentKey);
    chip.href = '#cal-m-' + key;
    chip.textContent = (g.y !== today.getFullYear() ? g.y + '年 ' : '') + g.m + '月';
    chip.setAttribute('data-chip', key);
    chip.setAttribute('aria-label', g.y + '年' + g.m + '月' + (key < currentKey ? '，過往月份' : key === currentKey ? '，目前月份' : ''));
    chip.addEventListener('click', function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      stopLanding();
      jumpTo(key, true);
    });
    chipsEl.appendChild(chip);
    g.chip = chip;
  });
  chipsEl.addEventListener('scroll', railState, { passive: true });

  function setVars() {
    root.style.setProperty('--neko-cal-header-h', headerH() + 'px');
    root.style.setProperty('--neko-cal-nav-h', navEl.offsetHeight + 'px');
    map[order[order.length - 1]].element.style.minHeight = Math.max(0, window.innerHeight - topOffset()) + 'px';
    if (activeKey) revealChip(map[activeKey].chip);
    railState();
    alignLanding();
  }
  function onScroll() {
    var probe = topOffset() + 2;
    var active = order[0];
    order.forEach(function (key) {
      if (map[key].element.getBoundingClientRect().top <= probe) active = key;
    });
    setActive(active);
  }
  var scrollFrame = 0;
  window.addEventListener('scroll', function () {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(function () { scrollFrame = 0; onScroll(); });
  }, { passive: true });
  function stopLanding() {
    landing = false;
    cancelAnimationFrame(landingFrame);
  }
  window.addEventListener('pointerdown', stopLanding, { passive: true });
  window.addEventListener('wheel', stopLanding, { passive: true });
  window.addEventListener('touchstart', stopLanding, { passive: true });
  window.addEventListener('keydown', stopLanding);
  function locationKey() {
    var key = window.location.hash.replace(/^#cal-m-/, '');
    return map[key] ? key : currentKey;
  }
  function restoreLocation() { jumpTo(locationKey(), false); }
  function alignLanding() {
    if (!landing) return;
    cancelAnimationFrame(landingFrame);
    landingFrame = requestAnimationFrame(function () {
      if (!landing) return;
      restoreLocation();
      revealChip(map[activeKey].chip, true);
    });
  }
  function navigateHistory() {
    stopLanding();
    restoreLocation();
  }
  window.addEventListener('hashchange', navigateHistory);
  window.addEventListener('popstate', navigateHistory);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      stopLanding();
      setVars();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          onScroll();
          revealChip(map[activeKey].chip, true);
        });
      });
    } else {
      setVars();
    }
  });
  window.addEventListener('resize', setVars);
  window.addEventListener('load', setVars);
  if ('ResizeObserver' in window) {
    var observer = new ResizeObserver(setVars);
    observer.observe(navEl);
    var header = document.querySelector('.neko-header-section');
    if (header) observer.observe(header);
  }
  setVars();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(setVars);
  alignLanding();
})();
